<template>
  <div class="col-12">
    <div class="col-12" style="margin-top: 10px">
      <h4 style="color: black">
        Add New Animal
        <b-btn
          class="btn-danger float-right"
          style="text-align: right; margin-right: 5px"
          @click="go_back()"
        >
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn>
      </h4>

      <hr />
    </div>
    <div id="surveyContainer">
      <survey :survey="survey"></survey>
    </div>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";

var Survey = SurveyVue.Survey;
Survey.cssType = "bootstrap";

export default {
  components: { Survey },
  data() {
    return {
      survey: new SurveyVue.Model({}),
      model: {
        title: "",
        logoPosition: "right",
        pages: [
          {
            name: "page1",
            elements: [
              {
                type: "text",
                name: "Tag",
                title: "Animal Tag No :",
              },
              {
                type: "dropdown",
                name: "Animal type",
                visible: false,
                visibleIf: "{Tag} notempty",
                title: "Type of Animal",
                choices: [
                  {
                    value: "item1",
                    text: "Cow",
                  },
                  {
                    value: "item2",
                    text: "Buffalo",
                  },
                  {
                    value: "item3",
                    text: "Goat",
                  },
                  {
                    value: "item4",
                    text: "Ox",
                  },
                ],
              },
              {
                type: "radiogroup",
                name: "animal breed",
                visible: false,
                visibleIf: "{Animal type} notempty",
                title: "Animal Breed",
                choices: [
                  {
                    value: "item1",
                    text: "Cross / Hybrid",
                  },
                  {
                    value: "item2",
                    text: "Deshi",
                  },
                ],
              },
              {
                type: "dropdown",
                name: "breed bane deshi -cow",
                visibleIf:
                  "{animal breed} = 'item2' and {Animal type} = 'item1'",
                title: "Breed Name (Deshi - Cow )",
                choices: ["Amritmahal", "Bachaur", "Badri"],
                hideIfChoicesEmpty: true,
              },
              {
                type: "dropdown",
                name: "Breed Name Deshi - Ox",
                visibleIf:
                  "{animal breed} = 'item2' and {Animal type} = 'item4'",
                title: "Breed Name (Deshi - Ox)",
                choices: ["Amritmahal", "Bachaur", "Badri"],
                hideIfChoicesEmpty: true,
              },
              {
                type: "dropdown",
                name: "Breed Name Deshi - Buffalos",
                visibleIf:
                  "{animal breed} = 'item2' and {Animal type} = 'item2'",
                title: "Breed Name (Deshi - Buffalos)",
                choices: ["Amritmahal", "Bachaur", "Badri"],
                hideIfChoicesEmpty: true,
              },
              {
                type: "dropdown",
                name: "Breed Name Deshi - Goat",
                visibleIf:
                  "{animal breed} = 'item2' and {Animal type} = 'item3'",
                title: "Breed Name (Deshi - Goat)",
                choices: ["Amritmahal", "Bachaur", "Badri"],
                hideIfChoicesEmpty: true,
              },
              {
                type: "dropdown",
                name: "Breed name cross - cow",
                visibleIf:
                  "{animal breed} = 'item1' and {Animal type} = 'item1'",
                title: "Breed Name (Cross / Hybrid -cow)",
                choices: [
                  {
                    value: "Amritmahal",
                    text: "Brown Swiss",
                  },
                  {
                    value: "Bachaur",
                    text: "Holstein Friesian",
                  },
                  {
                    value: "Badri",
                    text: "Jersey",
                  },
                ],
                hideIfChoicesEmpty: true,
              },
              {
                type: "dropdown",
                name: "Breed name cross - ox",
                visibleIf:
                  "{animal breed} = 'item1' and {Animal type} = 'item4'",
                title: "Breed Name (Cross / Hybrid - Ox)",
                choices: [
                  {
                    value: "Amritmahal",
                    text: "Brown Swiss",
                  },
                  {
                    value: "Bachaur",
                    text: "Holstein Friesian",
                  },
                  {
                    value: "Badri",
                    text: "Jersey",
                  },
                ],
                hideIfChoicesEmpty: true,
              },
              {
                type: "dropdown",
                name: "Breed name Cross - Buffalos",
                visibleIf:
                  "{animal breed} = 'item1' and {Animal type} = 'item2'",
                title: "Breed Name (Cross / Hybrid - Buffalos)",
                choices: [
                  {
                    value: "Amritmahal",
                    text: "Brown Swiss",
                  },
                  {
                    value: "Bachaur",
                    text: "Holstein Friesian",
                  },
                  {
                    value: "Badri",
                    text: "Jersey",
                  },
                ],
                hideIfChoicesEmpty: true,
              },
              {
                type: "dropdown",
                name: "Breed Name Cross - Goat",
                visibleIf:
                  "{animal breed} = 'item1' and {Animal type} = 'item3'",
                title: "Breed Name (Cross / Hybrid - Goat)",
                choices: [
                  {
                    value: "Amritmahal",
                    text: "Brown Swiss",
                  },
                  {
                    value: "Bachaur",
                    text: "Holstein Friesian",
                  },
                  {
                    value: "Badri",
                    text: "Jersey",
                  },
                ],
                hideIfChoicesEmpty: true,
              },
              {
                type: "text",
                name: "Age",
                visibleIf: "{animal breed} notempty",
                title: "Age ?",
                valueName: "1",
                inputType: "number",
                min: "1",
                step: 1,
              },
              {
                type: "text",
                name: "Color",
                visibleIf: "{Animal type} = 'item4'",
                title: "Color ?",
                inputType: "color",
              },
              {
                type: "radiogroup",
                name: "In milking days",
                visible: false,
                visibleIf: "{Animal type} <> 'item4' and {1} notempty",
                title: "In Milking Days ?",
                choices: [
                  {
                    value: "item1",
                    text: "Yes , Milking",
                  },
                  {
                    value: "item2",
                    text: "No , Dry Now / Not Milking",
                  },
                ],
              },
              {
                type: "text",
                name: "Milking Yeild",
                visible: false,
                visibleIf:
                  "{Animal type} <> 'item4' and {In milking days} = 'item1'",
                title: "Milking Yield ( Per Day / Liters)",
                inputType: "number",
                min: "0",
                max: "40",
              },
              {
                type: "boolean",
                name: "is pregnant",
                visible: false,
                visibleIf: "{Animal type} <> 'item4' and {1} notempty",
                title: "Is Pregnant ? ",
              },
              {
                type: "text",
                name: "No of Parturition",
                visible: false,
                visibleIf:
                  "{Animal type} <> 'item4' and {Tag} notempty and {is pregnant} = true",
                title: "No of Parturition ? ",
                inputType: "number",
                min: "1",
                max: "20",
              },
              {
                type: "text",
                name: "pregnancy month",
                visible: false,
                visibleIf: "{Animal type} <> 'item4' and {is pregnant} = true",
                title: "Pregnancy Month ?",
                inputType: "number",
                min: "1",
                max: "12",
              },
              {
                type: "boolean",
                name: "is calved",
                visible: false,
                visibleIf: "{Animal type} <> 'item4' and {1} notempty",
                title: "Is Calve ? ",
              },
              {
                type: "text",
                name: "last calved date",
                visibleIf: "{Animal type} <> 'item4' and {is calved} = true",
                title: "Last Calved Date ?",
                inputType: "date",
              },
              {
                type: "radiogroup",
                name: "last calved gender",
                visibleIf: "{Animal type} <> 'item4' and {is calved} = true",
                title: "Last Calved Gender ?",
                choices: [
                  {
                    value: "item1",
                    text: "Male",
                  },
                  {
                    value: "item2",
                    text: "Female",
                  },
                ],
              },
              {
                type: "text",
                name: "total Parturition",
                visibleIf: "{Animal type} <> 'item4' and {is pregnant} = false",
                title: "Total Parturition ? ",
                inputType: "number",
                min: "0",
                max: "20",
              },
              {
                type: "file",
                name: "question1",
                visible: false,
                visibleIf: "{Tag} notempty",
                title: "Upload Image ",
              },
            ],
          },
          {
            name: "page2",
          },
        ],
        showPageNumbers: true,
        showPreviewBeforeComplete: "showAllQuestions",
        widthMode: "responsive",
      },
    };
  },

  mounted() {
    this.survey = new SurveyVue.Model(this.model);

    var myCss = {
      matrix: {
        root: "table table-striped",
      },
      navigationButton: "button btn-sm btn-primary",
      title: "font-weight-normal text-lg",
      //   navigation:{
      //       next: "button btn-outline-success"
      //   },
    };

    this.survey.css = myCss;

    this.survey.onComplete.add(function (survey, options) {
      survey.clear(false);
      if (survey.mode == "display") {
        survey.currentPage = 0;
        return;
      }
      alert(JSON.stringify(survey.data));
      //   sendDataToServer(survey, survey.currentPageNo, true);
      //   this.SaveData(survey, survey.currentPageNo, true);
      //   router.push("/agencypayment");
    });
  },
  methods: {
    go_back() {
      this.$router.go(-1);
    },
  },
};
</script>
